import TenantSelectFreeSolo from "components/molecules/TenantSelectFreeSolo";
import React, { useEffect, useState } from "react";
import Props from "./index.d";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { tenantIdAtom, isPrivateTenantCheckedAtom } from "./state";
import { userIsPlatformOperatorAtom } from "pages/UserProfile/recoil";
import { Checkbox, FormControlLabel, Typography } from "@mui/material";
import { translations } from "translations";
import { useGetUsersQuery } from "graphqlBase/userManagement/user/__generated__/getUsers";
import { userIdState } from "pages/UserManagement/UpdateUserAndTenant/state";

const titleStyle = {
  color: "#00000099",
  fontSize: "1rem",
  marginBottom: "0.35rem",
};

const TenantIdForUser: React.FC<Props> = (props) => {
  const userIsPlatformOperator = useRecoilValue(userIsPlatformOperatorAtom);
  const userId = useRecoilValue(userIdState);

  const { data: userData } = useGetUsersQuery({
    variables: {
      where: {
        id: { eq: String(userId) },
      },
    },
  });

  const isPrivateTenant = userData?.users?.items?.[0]?.tenant?.isPrivate;

  const {
    data: { state, setstate, setNull },
    pickDefaultFirst,
    disabled,
  } = props;

  const [tenantId, setTenantId] = useRecoilState(tenantIdAtom);

  const setIsPrivateTenant = useSetRecoilState(isPrivateTenantCheckedAtom);
  const [checked, setChecked] = useState(false);
  const [previousTenantId, setPreviousTenantId] = useState<string | null>(tenantId);

  useEffect(() => {
    if (state && state !== tenantId && !checked) {
      setTenantId(state);
    }
  }, [state, tenantId, checked, setTenantId]);
  const handleChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = event.target.checked;
    setChecked(isChecked);
    setIsPrivateTenant(isChecked);
    if (isChecked) {
      setPreviousTenantId(tenantId);
      setTenantId(null);
      setNull?.();
      setstate("");
    } else {
      setTenantId(previousTenantId);
      setstate(previousTenantId ?? "");
    }
  };
  useEffect(() => {
    if (!checked) {
      setPreviousTenantId(tenantId);
    }
  }, [checked, tenantId]);

  return (
    <>
      <Typography aria-label={translations.entities.tenant.plural} sx={titleStyle} variant="h2">
        {translations.entities.tenant.plural}
      </Typography>
      {!checked ? (
        <TenantSelectFreeSolo
          pickDefaultFirst={pickDefaultFirst}
          disabled={disabled || !userIsPlatformOperator}
          value={state}
          handleSaveTenant={(tenant) => {
            if (!tenant) {
              setNull?.();
              setstate("");
            } else {
              setstate(tenant.value);
            }
          }}
        />
      ) : null}
      {!isPrivateTenant && userIsPlatformOperator && (
        <FormControlLabel
          label={translations.entities.tenant.privateTenant}
          control={<Checkbox checked={checked} onChange={handleChange} />}
        />
      )}
    </>
  );
};

export default TenantIdForUser;
